// Wording for the profile-connection journey (/connect-profile) and the member
// attendance prompt. Churches and ministries, and older records with no type
// (all churches), keep the original church wording exactly; every other
// organization type (Cuisine, MC, schools, ...) gets neutral wording that
// names the organization.
import {supportsOrganizationCapability} from "../config/websiteVerticalContract";

export function isChurchLike(org = {}) {
  return supportsOrganizationCapability(org, "churchProfileWording");
}

export function profileConnectWording(org = {}, name = "") {
  if (isChurchLike(org)) {
    return {
      title: "Connect your church profile",
      intro: "Verify the mobile number you use for church check-in. We’ll look for your existing profile.",
      missingOrg: "Open this page from your church website so we can connect the right directory.",
      keepsAccess: "Your church profile, history, and access stay with your existing account.",
      checking: "Checking your church profile…",
      existingAccount: "You already have a church account",
      contactAdmin: "contact your church administrator",
      completeProfile: "Complete your church profile",
      noMatchHelp: "Your church can help connect it.",
      reviewHelp: "Please contact your church administrator.",
      attendancePrompt: "Connect your church profile to view your attendance history.",
      accessNoMatch:
        "Your email has been verified, but we couldn't connect this account to an existing church profile. " +
        "Contact the organization if you believe you should have access.",
      verifyBeforeConnect: "before we connect your existing church profile and history.",
    };
  }
  const orgName = String(name || "").trim();
  const team = orgName ? `${orgName}` : "the organization";
  return {
    title: "Connect your profile",
    intro: `Verify the mobile number you use with ${team}. We’ll look for your existing profile.`,
    missingOrg: "Open this page from the organization’s website so we can connect the right directory.",
    keepsAccess: "Your profile, history, and access stay with your existing account.",
    checking: "Checking your profile…",
    existingAccount: orgName ? `You already have an account with ${orgName}` : "You already have an account",
    contactAdmin: `contact ${team}`,
    completeProfile: "Complete your profile",
    noMatchHelp: `${orgName || "The organization"} can help connect it.`,
    reviewHelp: `Please contact ${team}.`,
    attendancePrompt: "Connect your profile to view your attendance history.",
    accessNoMatch:
      `Your email has been verified, but this account isn't connected to a profile at ${team}. ` +
      `Contact ${team} if you believe you should have access.`,
    verifyBeforeConnect: `before we connect your existing profile and history with ${team}.`,
  };
}
